
const Channel = ({ children }) => {
  return (
    <div className='channel'>
      {children}
    </div>
  );
};

export default Channel;
